import * as types from 'store/mutation-types'

const state = {
  intro: null,
  industry: null,
  research: null,
  cross: null,
  funds: null,
  orgHoldings: null,
  etfData: null,
  buyback: null
}

function parseTargetData(data) {
  if (!data) {
    return {}
  }

  const blueprint = {
    name: data.name,
    text: data.text,
    chart: []
  }
  data.chart.lines.map(val => blueprint.chart.push(val.item))
  const parsedData = Object.assign({}, blueprint)
  return parsedData
}

function parseForecastData(data) {
  if (!data) {
    return {}
  }

  const blueprint = {
    name: data.name,
    text: data.text,
    title: data.eps.chart.title,
    unit: data.eps.chart.unit,
    chart: []
  }
  data.eps.chart.lines.map(val => blueprint.chart.push(val.item))
  const parsedData = Object.assign({}, blueprint)
  return parsedData
}

function parseRecommendation(data) {
  if (!data) {
    return {}
  }
  if (!data.recommendation) {
    return {}
  }
  const dataObject = {
    recommendation: data.recommendation
  }
  if (data.researchDetail) {
    dataObject.table = data.researchDetail.table
  }
  return dataObject
}
function parseFundsChange(data) {
  if (!data) {
    return {}
  }
  if (!data.positionChange) {
    return {}
  }
  const dataObject = {
    positionChange: data.positionChange,
    unit: data.unit
  }
  return dataObject
}

function parseEtfData(data) {
  if (!data || Object.keys(data).length === 0) {
    return {}
  }
  // 1week 1 month, 6 months, 1 year, ytd
  const periods = {
    '1week': true,
    '1month': true,
    '3month': false,
    '6month': true,
    '1year': true,
    ytd: true
  }
  const dataObj = { ...data }
  dataObj.compEarnings = []
  dataObj.stockEarnings = dataObj.stockEarnings || []
  dataObj.compareEarnings = dataObj.compareEarnings || []
  dataObj.stockEarnings.forEach((earn, idx) => {
    const spy = dataObj.compareEarnings[idx]
    if (spy && spy.period === earn.period && periods[earn.period]) {
      dataObj.compEarnings.push({
        period: earn.period,
        earnings: earn.weight,
        spy: spy.weight
      })
    }
  })
  return dataObj
}

const getters = {
  companyIntro(state) {
    if (state.etfData) {
      const etfIntro = {
        description: state.etfData.description,
        issuer: state.etfData.issuer
      }
      return etfIntro
    }
    return state.intro || {}
  },
  companyIndustry(state) {
    return state.industry || []
  },
  companyTargetData(state) {
    return state.research ? parseTargetData(state.research.targetForecast) : {}
  },
  companyForecastData(state) {
    return state.research
      ? parseForecastData(state.research.earningForecast)
      : {}
  },
  recommendationData(state) {
    return state.research ? parseRecommendation(state.research) : {}
  },
  hkCrossVolume(state) {
    return state.cross ? state.cross : []
  },
  companyFunds(state) {
    if (!state.funds || !state.funds.cashFlowList) {
      return []
    }
    return state.funds.cashFlowList
  },
  cashFlow(state) {
    if (!state.funds || !state.funds.cashFlowStat) {
      return {}
    }
    return state.funds.cashFlowStat
  },
  companyFundsChange(state) {
    return state.funds ? parseFundsChange(state.funds) : {}
  },
  orgHoldingsData(state) {
    return state.orgHoldings ? state.orgHoldings : {}
  },
  companyEarnings(state) {
    return state.research && state.research.earningsHistory
      ? state.research.earningsHistory
      : {}
  },
  etfBrief(state) {
    return state.etfData ? parseEtfData(state.etfData) : {}
  },
  hkBuybackData(state) {
    return state.buyback ? state.buyback : []
  }
}

const mutations = {
  [types.LOAD_BRIEF_DATA](state, data) {
    Object.keys(state).map(val => {
      state[val] = null
    })
    Object.assign(state, data)
  },
  [types.CLEAR_BRIEF_DATA](state) {
    Object.keys(state).map(val => {
      state[val] = null
    })
  }
}

const actions = {
  loadBriefInfo({ commit, dispatch }, { symbol, market, isEtf }) {
    // dispatch('clearBriefInfo')
    const briefLoadMap = {
      US: 'loadUsBriefInfo',
      HK: 'loadHkBriefInfo',
      SH: 'loadCnBriefInfo',
      SZ: 'loadCnBriefInfo'
    }
    if (isEtf) {
      return dispatch('loadEtfBriefInfo', { symbol, market })
    } else {
      return dispatch(briefLoadMap[market], { symbol, market })
    }
  },
  clearBriefInfo({ commit }) {
    commit(types.CLEAR_BRIEF_DATA)
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}
